<template>
  <div id="addressMap">
    <div id="container" class="contain"></div>
    <div id="myPageTop">
      <van-search
        v-model="value"
        id="yongchedidian"
        placeholder="搜索城市名+地名"
        @input="initMap"
      />
    </div>
    <div class="myPage">
      <div class="myPage_list" v-for="(item, i) in list" :key="i">
        <div
          @click="
            index = i
            setCenter(item)
          "
          class="myPage_lists"
        >
          <div class="myPage_listss">
            <div class="myPage_name">{{ item.name }}</div>
            <div class="myPage_district">
              {{ item.district
              }}{{ Array.isArray(item.address) ? '' : item.address }}
            </div>
          </div>
          <div class="duihao">
            <van-icon name="success" v-if="i === index" />
          </div>
        </div>
      </div>
    </div>
    <div class="dibu">
      <div class="daka">
        <div>打卡范围:</div>
        <van-dropdown-menu direction="up">
          <van-dropdown-item v-model="value1" :options="options" />
        </van-dropdown-menu>
      </div>
      <div class="queding" @click="confirmClickIn">确定</div>
    </div>
  </div>
</template>

<script>
import { getLocalStorage } from '@utils'
export default {
  components: {},
  data() {
    return {
      value: '',
      map: '',
      list: [],
      index: '',
      value1: 300,
      options: [
        { text: '100', value: 100 },
        { text: '200', value: 200 },
        { text: '300', value: 300 },
        { text: '400', value: 400 },
        { text: '500', value: 500 },
        { text: '1000', value: 1000 },
        { text: '1500', value: 1500 },
        { text: '2000', value: 2000 }
      ],
      condition: {}
    }
  },
  computed: {},
  watch: {},

  created() { },
  mounted() {
    this.map = new AMap.Map('container', {
      resizeEnable: true
    })
    this.map.setZoom(16)
    if (JSON.parse(getLocalStorage('nowPoint'))) {
      let point = JSON.parse(getLocalStorage('nowPoint'))
      console.log(point.lng)

      this.map.setCenter([point.lng, point.lat])
      var marker = new AMap.Marker({
        position: new AMap.LngLat(point.lng, point.lat) // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
      })
      this.map.add(marker)
    }
  },
  methods: {
    /**
     * @description 百度转高德经纬度
     * @param {string} name 名称
     */
    bd_encrypt(lng, lat) {
      var X_PI = (Math.PI * 3000.0) / 180.0
      var x = lng - 0.0065
      var y = lat - 0.006
      var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * X_PI)
      var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * X_PI)
      var bd_lng = z * Math.cos(theta)
      var bd_lat = z * Math.sin(theta)
      return {
        bd_lng: bd_lng,
        bd_lat: bd_lat
      }
    },

    confirmClickIn() {
      this.condition.ranges = this.value1
      if (this.condition.lat) {
        this.$emit('getPoint', this.condition)
      } else {
        this.$notify({
          type: 'success',
          message: '请选择地址'
        })
      }
    },

    /**
     * @description 高德转百度经纬度
     * @param {string} name 名称
     */
    gaoDeToBaidu(gd_lon, gd_lat) {
      var PI = (3.14159265358979324 * 3000.0) / 180.0
      var x = gd_lon
      var y = gd_lat
      var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * PI)
      var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * PI)
      var bd_lng = z * Math.cos(theta) + 0.0065
      var bd_lat = z * Math.sin(theta) + 0.006
      return {
        lng: bd_lng,
        lat: bd_lat
      }
    },
    setCenter(item) {
      // console.log(item);
      this.map.setCenter(item.location)
      // 移除已创建的 marker
      // this.map.remove(marker);
      this.map.clearMap()
      if (item.location) {
        var marker = new AMap.Marker({
          position: new AMap.LngLat(item.location.lng, item.location.lat) // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        })
        // this.condition = this.gaoDeToBaidu(item.location.lng, item.location.lat)
        this.condition = { lng: item.location.lng, lat: item.location.lat }
        this.condition.placeName = item.name
        this.condition.address =
          item.district + (Array.isArray(item.address) ? '' : item.address)

        this.map.setZoom(15)

        // 将创建的点标记添加到已有的地图实例：
        this.map.add(marker)
      }
    },
    initMap() {
      var autoComplete = new AMap.Autocomplete()
      let that = this
      autoComplete.search(this.value, function (status, result) {
        that.list = result.tips
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#addressMap {
  height: 100%;
  .contain {
    height: 250px;
  }
  .myPage {
    height: calc(100% - 370px);
    padding: 0 10px;
    border-top: 1px solid #eaeaea;
    overflow: auto;
    .myPage_list {
      border-bottom: 1px solid #eaeaea;

      .myPage_lists {
        display: flex;
        align-items: center;
        .myPage_listss {
          flex: 9;
          .myPage_name {
            color: #4e4e4e;
            margin-bottom: 5px;
            margin-top: 5px;
          }
          .myPage_district {
            color: #999;
            margin-bottom: 5px;
          }
        }
        .duihao {
          flex: 1;
          color: #0091ff;
        }
      }
    }
  }
  .dibu {
    border-top: 1px solid #eaeaea;
    height: 60px;
    display: flex;
    line-height: 50px;
    align-items: center;
    background-color: #fff;
    padding: 0 10px;
    /deep/.van-dropdown-menu {
      //   width: 100px;
    }
    /deep/.van-dropdown-menu__bar {
      box-shadow: 0 0 0 0;
    }
    .daka {
      display: flex;
      line-height: 50px;
      align-items: center;
      flex: 7;
    }
    .queding {
      flex: 3;
      width: 80px;
      height: 40px;
      border-radius: 8px;
      line-height: 40px;
      text-align: center;
      background-color: rgba(0, 145, 255, 1);
      color: #fff;
    }
  }
}
</style>
